/**
 * Global science – mobile Swiper
 * Desktop: static grid. Mobile: Swiper with arrows + pagination.
 */
(() => {
  const BREAKPOINT = 768;
  const instances = new WeakMap();

  const isMobile = () => window.innerWidth < BREAKPOINT;

  const getControls = (gallery) => {
    if (!gallery) return {};
    return {
      prevEl: gallery.querySelector('.global-science__nav--prev'),
      nextEl: gallery.querySelector('.global-science__nav--next'),
      paginationEl: gallery.querySelector('.global-science__pagination')
    };
  };

  const destroySlider = (el) => {
    const swiper = instances.get(el);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(el);
    el.classList.remove('global-science__slider--active');
  };

  const getSwiper = () => window.Swiper || (typeof Swiper !== 'undefined' ? Swiper : null);

  const initSlider = (el) => {
    if (!el || instances.has(el) || !isMobile()) return;
    const SwiperClass = getSwiper();
    if (!SwiperClass) return false;

    const gallery = el.closest('.global-science__gallery');
    const { prevEl, nextEl, paginationEl } = getControls(gallery);
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    if (slideCount < 1) return true;

    const swiper = new SwiperClass(el, {
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      speed: 500,
      threshold: 5,
      grabCursor: true,
      watchOverflow: true,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : undefined,
      on: {
        init: () => {
          el.classList.add('global-science__slider--active');
        },
        destroy: () => {
          el.classList.remove('global-science__slider--active');
        }
      }
    });

    instances.set(el, swiper);
    return true;
  };

  const updateAll = () => {
    document.querySelectorAll('[data-global-science-slider]').forEach((el) => {
      if (isMobile()) {
        if (!instances.has(el)) {
          let tries = 0;
          const tryInit = () => {
            const ok = initSlider(el);
            if (!ok && tries < 40) {
              tries += 1;
              window.setTimeout(tryInit, 100);
            }
          };
          tryInit();
        } else {
          const swiper = instances.get(el);
          if (swiper && typeof swiper.update === 'function') swiper.update();
        }
      } else {
        destroySlider(el);
      }
    });
  };

  let resizeTimer = null;
  const onResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateAll, 150);
  };

  const start = () => {
    updateAll();
    window.addEventListener('resize', onResize, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('swiper:loaded', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target) return;
    event.target.querySelectorAll('[data-global-science-slider]').forEach(destroySlider);
  });
})();
